import React, { Component } from "react";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ChemistView from "./ChemistView";
import ChemistActive from "./ChemistActive";
import ChemistOperation from "./ChemistOperation";

import "../../Common/Common.css";
var dateFormat = require("dateformat");

class ChemistProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ChemistuserShow: false,
      showChemistActive: false,
      showOprModePopUp: false,
      page: 0,
      perPage: 10,
      searchchemist: "",
      filterValue: "",
    };
  }

  componentDidMount() {
    this.props.ChemistUser({
      pageno: undefined,
      filter: this.state.filterValue,
      search: this.state.searchchemist,
    });
  }

  //Search function
  SearchOnChange = (event) => {
    this.setState(
      {
        filterValue: "",
        searchchemist: event.target.value,
        page: 0,
      },
      () => {
        this.props.ChemistUser({
          pageno: undefined,
          filter: "",
          search: this.state.searchchemist,
        });
      }
    );
  };

  //Filter function
  handleChange = (event) => {
    this.setState(
      {
        page: 0,
        filterValue: event.target.value,
        searchchemist: "",
      },
      () => {
        this.props.ChemistUser({
          pageno: undefined,
          filter: this.state.filterValue,
          search: "",
        });
      }
    );
  };

  //For pagination
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ChemistUserSlectedPage({
      pageno: selectedPage + 1,
      filter: this.state.filterValue,
      search: this.state.searchchemist,
    });
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handleChemistView = (item) => {
    this.setState({
      ChemistuserShow: true,
      ChemistuserDtls: item,
    });
    this.props.ChemistDetailsview(item.item.id);
    this.props.fetchchemistOfferDtls(item.item.id);
  };

  handleCloseChemistView = () => {
    this.setState({ ChemistuserShow: false });
  };

  handleChemistActiveView = (item) => {
    this.setState({
      showChemistActive: true,
      ChemistActiveDtls: item,
    });
  };

  handleChemistOprMode = (item) => {
    this.setState({
      showOprModePopUp: true,
      ChemistOperationDtls: item,
    });
  };

  handleCloseActive = () => {
    this.setState({ showChemistActive: false });
  };

  handleCloseOperationMode = () => {
    this.setState({ showOprModePopUp: false });
  };

  render() {
    //Destructuring
    const {
      page,
      perPage,
      searchchemist,
      filterValue,
      showChemistActive,
      showOprModePopUp,
      ChemistActiveDtls,
      ChemistOperationDtls,
      ChemistuserShow,
      ChemistuserDtls,
    } = this.state;
    const {
      chemistuserDtlsCount,
      chemistuserDtlsList,
      ChemistInActive,
      ChemistOprMode,
      chemistmainDtls,
      chemistOfferDtls,
      chemistOfferDtlsCount,
    } = this.props;
    const {
      SearchOnChange,
      handleChange,
      handlePageClick,
      handleChemistView,
      handleChemistActiveView,
      handleChemistOprMode,
      handleCloseActive,
      handleCloseOperationMode,
      resetPage,
      handleCloseChemistView,
    } = this;

    //For pagination
    let p = page + 1;
    const count = chemistuserDtlsCount ? chemistuserDtlsCount : 0;
    let ChemistUserPageCount = Math.ceil(count / perPage);

    return (
      <div>
        <Card>
          <Card.Header>
               <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Profiles</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={filterValue}
                    onChange={handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="active">Active</option>
                    <option value="suspended">Suspended</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInput">
                  <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                  <input
                    type="text"
                    placeholder="User/Org/Mobile No"
                    value={searchchemist}
                    onChange={SearchOnChange}
                  />
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count === undefined ? 0 : count}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th> USER NAME</th>
                    <th>ORG NAME</th>
                    <th>MOBILE </th>
                    <th>PROFILE UPDATE</th>
                    <th>MODE OF OPERATION</th>
                    <th>CREATED DATE</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>

                <tbody>
                  {chemistuserDtlsList &&
                    chemistuserDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.fullName ? item.fullName : ""}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orgName ? item.orgName : ""}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.mobileNo ? item.mobileNo : ""}
                        </td>
                        <td>
                          {item !== null && item.ftLogin
                            ? "Pending"
                            : "Updated"}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.oprMode ? item.oprMode : null}
                        </td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.status}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() => handleChemistView({ item: item })}
                            ></i>
                            <i
                              className="fa fa-ban fa-lg"
                              style={{ paddingLeft: 10 }}
                              onClick={() =>
                                handleChemistActiveView({ item: item })
                              }
                            ></i>
                            <ChemistActive
                              show={showChemistActive}
                              handleClose={handleCloseActive}
                              ChemistActiveDtls={ChemistActiveDtls}
                              ChemistInActive={ChemistInActive}
                              resetPage={resetPage}
                            />
                            {item !== null &&
                            item.oprMode &&
                            item.oprMode === "closed" ? (
                              <i
                                className="fa fa-lock fa-lg"
                                style={{ paddingLeft: 10 }}
                                onClick={() =>
                                  handleChemistOprMode({ item: item })
                                }
                              ></i>
                            ) : (
                              <i
                                className="fa fa-unlock-alt fa-lg"
                                style={{ paddingLeft: 10 }}
                                onClick={() =>
                                  handleChemistOprMode({ item: item })
                                }
                              ></i>
                            )}
                            <ChemistOperation
                              show={showOprModePopUp}
                              handleClose={handleCloseOperationMode}
                              ChemistOperationDtls={ChemistOperationDtls}
                              ChemistOprMode={ChemistOprMode}
                              resetPage={resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <ChemistView
                show={ChemistuserShow}
                handleClose={handleCloseChemistView}
                ChemistuserDtls={ChemistuserDtls}
                chemistmainDtls={chemistmainDtls}
                chemistOfferDtls={chemistOfferDtls}
                chemistOfferDtlsCount={chemistOfferDtlsCount}
              />

              {(chemistuserDtlsList === undefined ||
                (chemistuserDtlsList && chemistuserDtlsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../../src/assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Profiles Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {ChemistUserPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={ChemistUserPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default ChemistProfile;
